/* eslint-disable max-len */
import { call, put, takeLatest } from "redux-saga/effects";
import { setRequestInProcess } from "../request/actions";
import alertsNotificationsApiService from "../../services/alertsNotificationsApiService";
import * as actions from "./actions";
import { FETCHING_USER } from "./types";
import { showModal } from "../modal/actions";
import modalNames from "../../constants/modalNames";

function* fetchingUserAsync(action) {
  try {
    yield put(setRequestInProcess(FETCHING_USER, true));

    const response = yield call(userName => alertsNotificationsApiService.getUser(userName), action.payload);

    yield put(setRequestInProcess(FETCHING_USER, false));

    if (response.hasError) {
      yield put(actions.fetchingUserError(response.errors));
      yield put(
        showModal(modalNames.ERROR_MODAL, {
          errors: [
            {
              id: "You do not have permission to access this page. Please contact the help desk {{ helpDeskEmail }} if you think you should see this page.",
              data: {
                helpDeskEmail: process.env.REACT_APP_HELP_DESK_EMAIL,
                redirectAfterCloseUrl: process.env.REACT_APP_HEADER_LOGO_GO_TO_URL
              }
            }
          ]
        })
      );
    } else {
      yield put(actions.fetchingUserSuccess(response.payload));
    }
  } catch (err) {
    yield put(actions.fetchingUserError([err.message]));
  }
}

function* watchFetchingUserAsync() {
  yield takeLatest(FETCHING_USER, fetchingUserAsync);
}

export { watchFetchingUserAsync };
